module.exports = __webpack_public_path__ + "img/friendlogo.62eaba38.png";